const text = {
  registerCompleted: 'Register Completed',
  registerAgain: 'Register Again',
}
export default text
